// ----------------------------------------------------------------------
// <copyright file="Izenda.ChangePasswordPopupActions.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!(function() {
  var compose = require('recompose').compose;
  var withState = require('recompose').withState;
  var withHandlers = require('recompose').withHandlers;
  var CommonMessages = require('share/messages/Izenda.CommonMessages');

  var CANCEL_TEXT = 'cancel';
  var ACCEPT_TEXT = 'accept';
  const { curry, isNil } = require('lodash/fp');
  var ChangePasswordPopupActions = compose(
    withState('currentPassword', 'setCurrentPassword', ''),
    withState('newPassword', 'setNewPassword', ''),
    withState('confirmNewPassword', 'setConfirmNewPassword', ''),
    withHandlers({
      onClosing: curry(onClosing),
      updateCurrentPassword: curry(updateCurrentPassword),
      updateNewPassword: curry(updateNewPassword),
      updateConfirmNewPassword: curry(updateConfirmNewPassword)
    })
  );

  /**
   * Update current password
   */
  function updateCurrentPassword(props, input) {
    props.setCurrentPassword(input.target.value);
  }

  /**
   * Update new password
   */
  function updateNewPassword(props, input) {
    props.setNewPassword(input.target.value);
  }

  /**
   * Update confirm new password
   */
  function updateConfirmNewPassword(props, input) {
    props.setConfirmNewPassword(input.target.value);
  }

  /**
   * When click button OK on popup
   * @return {Promise} promise to handle async action
   */
  function onAcceptClosing(props) {
    var valManager = props.validation;
    var loader = props.loader;

    valManager
      .validate()
      .then(function(success) {
        if (success) {
          loader.startLoading();
          props.store.updateNewPassword(props.currentPassword, props.newPassword).then(function(result) {
            if (!isNil(result.messages)) {
              valManager.updateErrors(result.messages);
              props.store.model.alertMessage = {
                type: CommonMessages.MESSAGE_TYPE.ERROR,
                message: result.messages[0].messages[0]
              };
            } else {
              props.onAccept();
            }
            return null;
          });
        }
      })
      .finally(loader.endLoading.bind(loader));
  }

  /**
   * When click button Cancel on popup
   * @param  {Object} hidePopup function
   */
  function onCancelClosing(props) {
    props.validation.reset();
    props.onReject();
  }

  /**
   * Closing popup
   * @param {text} type
   */
  function onClosing(props, callback, type) {
    switch (type) {
      case ACCEPT_TEXT:
        onAcceptClosing(props);
        break;
      case CANCEL_TEXT:
        onCancelClosing(props);
        break;
    }
  }

  module.exports = ChangePasswordPopupActions;
})();



// WEBPACK FOOTER //
// ./ui/modules/MyProfile/SecurityOptions/Izenda.ChangePasswordPopupActions.js